module.exports = __webpack_public_path__ + "static/media/dpos.99818476.png";